import {
  Box,
  Card,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import { ReactElement } from 'react';
import PageHeader from 'shared/components/PageHeader';
import { ReactComponent as AuditReady } from 'assets/images/ic_audit_readiness.svg';

const AuditDocument = (): ReactElement => (
  <Box className="sys-document-wrapper">
    <PageHeader
      title="System Failure Audit Trail"
      description="Track all system failure document activities and changes"
    />
    <Card variant="outlined">
      <CardContent>
        <SvgIcon
          component={AuditReady}
          inheritViewBox
          className="view-icon"
          fontSize="inherit"
          htmlColor="#3D3C42"
        />
        <Stack
          direction="column"
          spacing={4}
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="h6">No Audit Logs Yet</Typography>
          <Typography component="span">
            System failure document activities will appear here once you start
            uploading and managing documents.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  </Box>
);

export default AuditDocument;
